import React, { useState } from 'react';
import ButterflyAnimation from './ButterflyAnimation';
import ShikkiOverlay from './ShikkiOverlay';
import '../styles/secret-button.css';

const SecretButton = () => {
  const [showButterflies, setShowButterflies] = useState(false);
  const [showShikki, setShowShikki] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    setShowButterflies(true);
  };

  const handleAnimationComplete = () => {
    setShowButterflies(false);
    setShowShikki(true);
  };

  const handleCloseShikki = () => {
    setShowShikki(false);
  };

  return (
    <>
      <a
        href="#secret"
        onClick={handleClick}
        className="secret-button visible"
        aria-label="Secret link"
        title="You found the secret! 🌹"
      >
        {/* Rose Flower SVG Icon */}
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Rose petals */}
          <path
            d="M12 3C10.5 3 9.5 4 9 5C8.5 4 7.5 3 6 3C4 3 3 5 3 7C3 9 4.5 10.5 6 11.5C4.5 12.5 3 14 3 16C3 18 4 20 6 20C7.5 20 8.5 19 9 18C9.5 19 10.5 20 12 20C13.5 20 14.5 19 15 18C15.5 19 16.5 20 18 20C20 20 21 18 21 16C21 14 19.5 12.5 18 11.5C19.5 10.5 21 9 21 7C21 5 20 3 18 3C16.5 3 15.5 4 15 5C14.5 4 13.5 3 12 3Z"
            fill="currentColor"
            opacity="0.9"
          />
          {/* Rose center */}
          <circle cx="12" cy="11.5" r="2.5" fill="currentColor" />
          {/* Stem */}
          <path
            d="M12 14.5V21"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          {/* Leaves */}
          <path
            d="M12 17C10.5 16.5 9 17 8 18"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
          <path
            d="M12 18.5C13.5 18 15 18.5 16 19.5"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
        </svg>
      </a>
      
      {/* Show butterflies animation */}
      {showButterflies && <ButterflyAnimation onComplete={handleAnimationComplete} />}
      
      {/* Show secret overlay */}
      {showShikki && <ShikkiOverlay onClose={handleCloseShikki} />}
    </>
  );
};

export default SecretButton;
